import core from '@gin-betting/core';
import { last } from 'lodash';

const {
    constants: { ROUTE_DIVIDER },
} = core;

export default function removeLastSlash(route: string): string {
    if (last(route) === ROUTE_DIVIDER && route.length > 1) {
        return route.slice(0, -1);
    }

    return route;
}
